// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1UE9k","containerItemsCenter":"Skeleton_containerItemsCenter__3kx77"};